module.exports = __webpack_public_path__ + "6784ac3122b01747b2e3e6d3d9c552d4.MP3";